var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0046 0.258789C24.7016 0.258789 31.7547 7.31188 31.7547 16.0089C31.7547 24.7059 24.7016 31.759 16.0046 31.759C7.30754 31.759 0.254456 24.7059 0.254456 16.0089C0.254456 7.31188 7.30754 0.258789 16.0046 0.258789ZM12.7338 21.1246L8.87784 17.2654C8.22091 16.6081 8.22077 15.5362 8.87784 14.879C9.53504 14.222 10.6117 14.2261 11.2641 14.879L13.9826 17.5996L20.7452 10.837C21.4024 10.1798 22.4744 10.1798 23.1315 10.837C23.7887 11.4941 23.7878 12.567 23.1315 13.2233L15.1738 21.181C14.5176 21.8372 13.4446 21.8382 12.7875 21.181C12.7691 21.1625 12.7512 21.1438 12.7338 21.1247V21.1246Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.52f7a98f4e15a48b58f3a7b3d1398422.svg";
export { ForwardRef as ReactComponent };